"use client";

import { ProductFull } from "@api";
import { EuStockedProductGroup } from "@/app/(site)/europe/constants";
import { useText } from "@/app/(site)/europe/useTranslations";
import { Desktop } from "./Desktop";

/**
 * One category block — heading and sub head copied from the /products page, then the tiles
 * for the slugs of that category that are stocked in the EU.
 */
export const ProductGroup = ({
  group,
  products,
}: {
  group: EuStockedProductGroup;
  products: ProductFull[];
}) => {
  const title = useText(group.titleKey);
  const body = useText(group.bodyKey);

  if (!products.length) {
    return null;
  }

  return (
    <div className="mb-16 last:mb-0">
      <div className="max-w-[860px] mx-auto mb-10 text-center">
        <h3 className="font-semibold mb-4">{title}</h3>
        <p dangerouslySetInnerHTML={{ __html: body }} />
      </div>
      <Desktop products={products} />
    </div>
  );
};
